import React, { memo } from 'react';
import { Route, Routes } from 'react-router-dom';

import ThemeButtons from '../components/theme/ThemeButtons';
import CustomersHeader from './components/customers/CustomersHeader';
import UserManagementHeader from './components/user-management/UserManagementHeader';
import ProjectsHeader from './components/projects/ProjectsHeader';
import SettingsHeader from './components/settings/SettingsHeader';
import SonarDashboardHeader from './components/sonar-dashboard/SonarDashboardHeader';
import HeaderColumn from './components/header-column/HeaderColumn';
import ScoutHeader from './components/scout/ScoutHeader';
import UserProfile from './components/user-profile/UserProfile';
import AllProjectButton from './components/projects/AllProjectButton';
import SonarDataTableSwitch from './components/sonar-dashboard/SonarDataTableSwitch';
import SonarSettings from './components/sonar-dashboard/SonarSettings';
import AiPlaygroundHeader from './components/ai-playground/AiPlaygroundHeader';
import ResonanceHeader from './components/resonance/ResonanceHeader';
import ResonanceIvisButton from './components/resonance/ResonanceIvisButton';
import GenieHeader from './components/genie/GenieHeader';
import GenieGoHeader from './components/genie-go/GenieGoHeader';
import Id8Header from './components/id8/Id8Header';
import SonarCommonHeader from './components/sonar-common/SonarCommonHeader';
import ProjectRequestHeader from './components/project-request/ProjectRequestHeader';
import MultipleRoute from '../components/multiple-route/MultipleRoute';
import Activ8Header from './components/activ8/Activ8Header';

import './Header.scss';

const Header = () => {
  return (
    <header className='header'>
      <Routes>
        <Route path='/project/sonar/:id' element={<SonarDashboardHeader />} />
        <Route path='/project/sonar/collect-data/:id' element={<SonarCommonHeader />} />
        <Route path='/customers/*' element={<CustomersHeader />} />
        <Route path='/users/*' element={<UserManagementHeader />} />
        <Route path='/projects/*' element={<ProjectsHeader />} />
        <Route path='/project/scout/*' element={<ScoutHeader />} />
        <Route path='/project/genie/:id' element={<GenieHeader />} />
        <Route path='/project/genie-go/:id' element={<GenieGoHeader />} />
        <Route path='/project/id8/:id' element={<Id8Header />} />
        <Route path='/project/activ8/:id' element={<Activ8Header />} />
        <Route path='/project/scout/collect-data/*' element={<ScoutHeader />} />
        <Route path='/settings/*' element={<SettingsHeader />} />
        <Route path='/playground' element={<AiPlaygroundHeader />} />
        <Route path='/project/resonance/:id' element={<ResonanceHeader />} />
        <Route path='/project-request' element={<ProjectRequestHeader />} />
      </Routes>

      <HeaderColumn>
        <Routes>
          <Route
            path='/project/sonar/:id'
            element={
              <>
                <SonarSettings />
                <SonarDataTableSwitch />
              </>
            }
          />
          <Route path='/project/resonance/:id' element={<ResonanceIvisButton />} />
        </Routes>
        <MultipleRoute paths={['/projects/create/*', '/projects/edit/*']} element={<AllProjectButton />} />

        <div className='header_user-block'>
          <div className='theme-switch-wrapper'>
            <ThemeButtons />
          </div>

          <UserProfile />
        </div>
      </HeaderColumn>
    </header>
  );
};

export default memo(Header);
